// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useLayout } from '../layout-context'
import SideNavContent, {
  SideNavContentProps,
} from '@/app/shared/components/Layout/Navigation/SideNav/SideNavContent'

export default function AsideNavigation(props: SideNavContentProps) {
  const { useAside } = useLayout()

  if (useAside) return null
  return <SideNavContent {...props} />
}
